import { LoadingPage } from '@/components/LoadingPage';
import { graphql } from '@/gql/codegen/gql';
import { useQuery } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';
import RolePlayResultContainer from './-container';

type RolePlayResultSearch = {
  timeout?: boolean;
};

export const Route = createFileRoute(
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/role-play-result/',
)({
  component: component,
  validateSearch: (search: Record<string, unknown>): RolePlayResultSearch => {
    // validate and parse the search params into a typed state
    return {
      timeout: search.timeout === 'true' || search.timeout === true,
    };
  },
});

export const GET_ROLE_PLAY_RESULT = graphql(/* GraphQL */ `
  query GetRolePlayResult(
    $input: CourseLessonRolePlayResultInput!
    $embaUserAttendanceSlug: String!
    $embaCourseLessonSlug: String!
  ) {
    embaRolePlayResult(input: $input) {
      ...RolePlayResult
    }
    embaCourseLesson(
      embaUserAttendanceSlug: $embaUserAttendanceSlug
      embaCourseLessonSlug: $embaCourseLessonSlug
    ) {
      ...EmbaCourseLessonDetail
    }
  }
`);

function component() {
  const { userAttendanceSlug, lessonSlug } = Route.useParams();
  const { timeout } = Route.useSearch();

  // ポーリング時にローディング表示を避けるため、useSuspenseQuery ではなく useQuery を使用
  const { startPolling, stopPolling, error, data } = useQuery(
    GET_ROLE_PLAY_RESULT,
    {
      variables: {
        input: {
          embaUserAttendanceSlug: userAttendanceSlug,
          embaCourseLessonSlug: lessonSlug,
        },
        embaUserAttendanceSlug: userAttendanceSlug,
        embaCourseLessonSlug: lessonSlug,
      },
      notifyOnNetworkStatusChange: false,
    },
  );

  if (error) {
    throw error;
  }

  // useQuery を使用しているので、手動でローディングの制御が必要。
  // ローディングは、初回データ取得時（data = undefined）のみ表示させ、ポーリング中(data = キャッシュされた値を保持し続ける)は表示させない。
  if (!data) {
    return <LoadingPage />;
  }

  return (
    <RolePlayResultContainer
      rolePlayResult={data.embaRolePlayResult}
      embaCourseLesson={data.embaCourseLesson}
      lessonSlug={lessonSlug}
      userAttendanceSlug={userAttendanceSlug}
      startPolling={startPolling}
      stopPolling={stopPolling}
      isTimeout={!!timeout}
    />
  );
}
